import { effect, inject, Injectable, untracked } from '@angular/core';
import { ActiveSavedSearchStore } from '@features/saved-search/store/active-saved-search.store';
import { CHATBOT_CONTEXT_IDS } from '../constants/chatbot-contexts';
import { ChatbotContextService } from './chatbot-context';

@Injectable({ providedIn: 'root' })
export class ChatbotSavedSearchContextService {
    private readonly contextService = inject(ChatbotContextService);
    private readonly activeSavedSearchStore = inject(ActiveSavedSearchStore);

    initialize(): void {
        effect(() => {
            const search = this.activeSavedSearchStore.activeSavedSearch();

            untracked(() => {
                if (!search) {
                    this.contextService.remove(CHATBOT_CONTEXT_IDS.ACTIVE_SAVED_SEARCH);

                    return;
                }

                this.contextService.set(
                    CHATBOT_CONTEXT_IDS.ACTIVE_SAVED_SEARCH,
                    'Currently Loaded Search Filter',
                    `This is the ONE search filter currently loaded in the UI (not a list of all saved searches). Name: ${search.name}, ID: ${search.id}, Email Me: ${search.emailMeNewMatches}, Email Customer: ${search.emailCustomerNewMatches}`,
                    { id: String(search.id), name: search.name }
                );
            });
        });
    }
}
